import type { SiteControllerSettingBaseFormModel } from "../../../../base/type";
import type { SiteControllerSettingTllFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
};

export const baseViewModelToViewModelConverter = ({ viewModel: _viewModel }: Props) => {
	const {
		isDirty,
		hasError, //
		hotelID,

		tll,
	} = _viewModel;

	const viewModel: SiteControllerSettingTllFormModel["ViewModel"] = {
		isDirty,
		hasError,

		hotelID,
		tll,
	};

	return { viewModel };
};
